import { useQuery } from 'react-query';
import { axiosInstance } from '../services/apiClient';
import { DiagnosisReadDTO } from '../generated/api-client';
import { useAuth } from '../contexts/AuthContext';

/** Query key condivisa con le mutation che invalidano l'elenco completo. */
export const DIAGNOSIS_ALL_QUERY_KEY = ['diagnosis', 'all'] as const;

/**
 * Tutte le diagnosi (GET /diagnosis-all/). Disponibile per tutti gli utenti autenticati.
 */
export const useDiagnosisAll = () => {
  const { isAuthenticated } = useAuth();

  return useQuery<DiagnosisReadDTO[]>(
    DIAGNOSIS_ALL_QUERY_KEY,
    async () => {
      const { data } = await axiosInstance.get<DiagnosisReadDTO[]>('/diagnosis-all/');
      return data ?? [];
    },
    { enabled: isAuthenticated }
  );
};
